import API from "./api";

export default {
  fetchOptionsList() {
    return API().get(`options-lists`);
  },
  addOptionsList(props) {
    return API().post(`options-lists`, props);
  },
  updateOptionsList(props) {
    return API().put(`options-lists/${props.id}`, props);
  }
};
